let defaultRole = {
    name: '',
    description: '',
    permissions: []
};

export default defaultRole;

